// Оповещение админу о сбое (kind = alert) с областью (сервер iiko, ключ iikoCloud): «Не присылать по …»
// и «Вернуть». Оповещения о самом воркере — без области, их отключить нельзя (кнопки нет).
import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { fetchAlertMutes, muteAlertScope, unmuteAlertScope } from '../../services/notificationsService';
import { extractErrorMessage } from '../../utils/errors';
import { MUTED_TEXT_COLOR } from '../../styles/tokens';

const buttonSx = { minHeight: 44, textTransform: 'none', fontWeight: 600, borderRadius: '10px' };

export default function AlertMuteControl({ item }) {
  const scope = item.payload?.scope;
  const scopeTitle = item.payload?.scope_title || scope;
  const [muted, setMuted] = useState(null); // null — ещё не знаем
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!scope) return undefined;
    let alive = true;
    fetchAlertMutes()
      .then((mutes) => alive && setMuted(mutes.some((m) => m.scope === scope)))
      .catch(() => alive && setMuted(false));
    return () => {
      alive = false;
    };
  }, [scope]);

  if (!scope || muted === null) return null;

  const toggle = async () => {
    setBusy(true);
    setError('');
    try {
      const mutes = muted ? await unmuteAlertScope(scope) : await muteAlertScope(scope, scopeTitle);
      setMuted(mutes.some((m) => m.scope === scope));
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box>
      {muted ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
          <Typography sx={{ fontSize: '14px', color: MUTED_TEXT_COLOR }}>{`Оповещения по: ${scopeTitle} — отключены`}</Typography>
          <Button onClick={toggle} disabled={busy} sx={{ ...buttonSx, color: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' }}>
            Вернуть
          </Button>
        </Box>
      ) : (
        <Button onClick={toggle} disabled={busy} fullWidth sx={{ ...buttonSx, color: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' }}>
          {`Не присылать по: ${scopeTitle}`}
        </Button>
      )}
      {error && <Typography role="alert" sx={{ mt: 1, fontSize: '13px', color: '#ef6b6b' }}>{error}</Typography>}
    </Box>
  );
}
